import { render } from "./AboutFishnet.vue?vue&type=template&id=fe9cb568&scoped=true"
import script from "./AboutFishnet.vue?vue&type=script&lang=js"
export * from "./AboutFishnet.vue?vue&type=script&lang=js"

import "./AboutFishnet.vue?vue&type=style&index=0&id=fe9cb568&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe9cb568"]])

export default __exports__